import React from 'react';
import { useNavigate } from 'react-router';
import { StylishNewButton } from '../components/DesignSystems/New/StylishNewButton';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column align-items-center justify-content-center ">
      <h1 className="display-txt--lg mb-3">404 - Page Not Found</h1>
      <p className="mb-4">
        Sorry, the page you are looking for does not exist.
      </p>
      <StylishNewButton
        className="button button--primary"
        onClick={() => navigate('/hub')}
      >
        Go to Hub
      </StylishNewButton>
    </div>
  );
};

export default NotFound;
